import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const api = {
  // Public
  getApps: () => axios.get(`${API}/apps`).then(r => r.data),
  getApp: (id) => axios.get(`${API}/apps/${id}`).then(r => r.data),
  getMedia: () => axios.get(`${API}/media`).then(r => r.data),
  getSettings: () => axios.get(`${API}/settings`).then(r => r.data),
  submitContact: (data) => axios.post(`${API}/contact`, data).then(r => r.data),
  getTiers: () => axios.get(`${API}/tiers`).then(r => r.data),
  getFeaturedPackages: () => axios.get(`${API}/featured-packages`).then(r => r.data),
  getServicePackages: () => axios.get(`${API}/service-packages`).then(r => r.data),
  createServiceBooking: (data) => axios.post(`${API}/service-booking`, data).then(r => r.data),
  createServiceCheckout: (bookingId, originUrl) => axios.post(`${API}/service-checkout?booking_id=${bookingId}&origin_url=${encodeURIComponent(originUrl)}`).then(r => r.data),

  // Marketplace
  getMarketplaceProducts: (type = "") => axios.get(`${API}/marketplace/products${type ? `?product_type=${type}` : ""}`).then(r => r.data),
  getMarketplaceProduct: (id) => axios.get(`${API}/marketplace/products/${id}`).then(r => r.data),
  getFeaturedProducts: () => axios.get(`${API}/marketplace/featured`).then(r => r.data),

  // Checkout
  createCheckout: (data) => axios.post(`${API}/checkout/session`, data).then(r => r.data),
  getCheckoutStatus: (sessionId) => axios.get(`${API}/checkout/status/${sessionId}`).then(r => r.data),

  // Admin Auth
  login: (data) => axios.post(`${API}/admin/login`, data).then(r => r.data),

  // Admin CRUD
  createApp: (data, token) => axios.post(`${API}/admin/apps`, data, authHeader(token)).then(r => r.data),
  updateApp: (id, data, token) => axios.put(`${API}/admin/apps/${id}`, data, authHeader(token)).then(r => r.data),
  deleteApp: (id, token) => axios.delete(`${API}/admin/apps/${id}`, authHeader(token)).then(r => r.data),
  createMedia: (data, token) => axios.post(`${API}/admin/media`, data, authHeader(token)).then(r => r.data),
  updateMedia: (id, data, token) => axios.put(`${API}/admin/media/${id}`, data, authHeader(token)).then(r => r.data),
  deleteMedia: (id, token) => axios.delete(`${API}/admin/media/${id}`, authHeader(token)).then(r => r.data),
  getContacts: (token) => axios.get(`${API}/admin/contacts`, authHeader(token)).then(r => r.data),
  deleteContact: (id, token) => axios.delete(`${API}/admin/contacts/${id}`, authHeader(token)).then(r => r.data),
  getAdminCreators: (token) => axios.get(`${API}/admin/creators`, authHeader(token)).then(r => r.data),
  getAdminProducts: (token) => axios.get(`${API}/admin/products`, authHeader(token)).then(r => r.data),
  getAdminTransactions: (token) => axios.get(`${API}/admin/transactions`, authHeader(token)).then(r => r.data),
  getNonprofitApplications: (token) => axios.get(`${API}/admin/nonprofit-applications`, authHeader(token)).then(r => r.data),
  approveNonprofit: (id, token) => axios.put(`${API}/admin/nonprofit-applications/${id}/approve`, {}, authHeader(token)).then(r => r.data),
  rejectNonprofit: (id, token) => axios.put(`${API}/admin/nonprofit-applications/${id}/reject`, {}, authHeader(token)).then(r => r.data),
  getAdminPayouts: (token) => axios.get(`${API}/admin/payouts`, authHeader(token)).then(r => r.data),
  approvePayout: (id, token) => axios.put(`${API}/admin/payouts/${id}/approve`, {}, authHeader(token)).then(r => r.data),
  rejectPayout: (id, token) => axios.put(`${API}/admin/payouts/${id}/reject`, {}, authHeader(token)).then(r => r.data),
  updateSettings: (data, token) => axios.put(`${API}/admin/settings`, data, authHeader(token)).then(r => r.data),

  // Creator Auth
  creatorRegister: (data) => axios.post(`${API}/creator/register`, data).then(r => r.data),
  creatorLogin: (data) => axios.post(`${API}/creator/login`, data).then(r => r.data),
  getCreatorProfile: (token) => axios.get(`${API}/creator/profile`, authHeader(token)).then(r => r.data),
  getCreatorProducts: (token) => axios.get(`${API}/creator/products`, authHeader(token)).then(r => r.data),
  createProduct: (data, token) => axios.post(`${API}/creator/products`, data, authHeader(token)).then(r => r.data),
  updateProduct: (id, data, token) => axios.put(`${API}/creator/products/${id}`, data, authHeader(token)).then(r => r.data),
  deleteProduct: (id, token) => axios.delete(`${API}/creator/products/${id}`, authHeader(token)).then(r => r.data),
  getCreatorSales: (token) => axios.get(`${API}/creator/sales`, authHeader(token)).then(r => r.data),
  requestPayout: (data, token) => axios.post(`${API}/creator/payouts/request`, data, authHeader(token)).then(r => r.data),
  getCreatorPayouts: (token) => axios.get(`${API}/creator/payouts`, authHeader(token)).then(r => r.data),

  // Nonprofit
  applyNonprofit: (data, token) => axios.post(`${API}/nonprofit/apply`, data, authHeader(token)).then(r => r.data),

  // Reviews
  createReview: (data) => axios.post(`${API}/reviews`, data).then(r => r.data),
  getReviews: (productId) => axios.get(`${API}/reviews/${productId}`).then(r => r.data),

  // Analytics
  getAnalytics: (token) => axios.get(`${API}/admin/analytics`, authHeader(token)).then(r => r.data),
};
